/* Roles del staff de un evento: un solo lugar para los ids, nombres y
 * descripciones. Antes cada pantalla (Staff y el paso de colaboradores del
 * alta) tenía su propia copia de estas listas y de los switch que las
 * traducen, y había que arreglar todo dos veces.
 *
 * Los ids son los de la tabla roles; el backend valida los mismos en
 * controllers/participaciones (rolesValidos). */

export const ROL = {
  OWNER: 1,
  COLABORADOR: 2,
  CLIENTE: 3,
  CONTROL_ACCESO: 5,
  CONTROL_VOUCHER: 6,
  ADMIN_DATOS: 7,
  EXPOSITOR: 8,
  VENDEDOR: 9,
  TESORERO: 10,
};

export const TIPO_COLABORADOR = "colaborador";

/* Tipos que se eligen en el formulario. "Colaborador" no tiene id propio: se
 * completa con uno de los subtipos de abajo. */
export const TIPOS_ROL = [
  { value: "owner", idrol: ROL.OWNER, label: "Owner", description: "Acceso completo a todas las funciones y configuraciones del evento." },
  { value: "cliente", idrol: ROL.CLIENTE, label: "Cliente", description: "Acceso únicamente a reportes, estadísticas y seguimiento del evento." },
  { value: TIPO_COLABORADOR, idrol: null, label: "Colaborador", description: "Acceso limitado según el tipo de colaborador seleccionado." },
  { value: "expositor", idrol: ROL.EXPOSITOR, label: "Expositor", description: "Permite registrar información de asistentes mediante el escaneo de sus tickets de ingreso." },
  { value: "vendedor", idrol: ROL.VENDEDOR, label: "Vendedor", description: "Usuario encargado de la venta presencial de tickets y/o vouchers." },
  { value: "tesorero", idrol: ROL.TESORERO, label: "Tesorero", description: "Usuario encargado de la gestión financiera del evento." },
];

export const SUBTIPOS_COLABORADOR = [
  { idrol: ROL.COLABORADOR, label: "Colaborador General", description: "Rol encargado de diversas tareas como controlar el acceso y los vouchers." },
  { idrol: ROL.CONTROL_ACCESO, label: "Control de Acceso", description: "Rol encargado de controlar el acceso de las personas autorizadas al evento." },
  { idrol: ROL.CONTROL_VOUCHER, label: "Control de Voucher", description: "Rol encargado de controlar y gestionar el canje de los vouchers del evento." },
  { idrol: ROL.ADMIN_DATOS, label: "Administrador de datos", description: "Rol encargado de la carga y diseño de tickets." },
];

export const esColaborador = (idrol) =>
  SUBTIPOS_COLABORADOR.some((s) => s.idrol === Number(idrol));

/* "owner", "colaborador", "vendedor"... a partir del id. Es también el
 * memberType que espera DeleteStaffModal. */
export const tipoDeRol = (idrol) => {
  if (esColaborador(idrol)) return TIPO_COLABORADOR;
  return TIPOS_ROL.find((t) => t.idrol === Number(idrol))?.value ?? null;
};

/* Nombre para mostrar: el del subtipo si es colaborador. */
export const nombreRol = (idrol) =>
  SUBTIPOS_COLABORADOR.find((s) => s.idrol === Number(idrol))?.label ??
  TIPOS_ROL.find((t) => t.idrol === Number(idrol))?.label ??
  "Desconocido";

/* El id final a partir de lo elegido en el formulario. Para colaborador hace
 * falta el subtipo; sin él devuelve null (selección incompleta). */
export const idrolDeSeleccion = (tipo, idrolSubtipo) => {
  if (tipo === TIPO_COLABORADOR) return idrolSubtipo ?? null;
  return TIPOS_ROL.find((t) => t.value === tipo)?.idrol ?? null;
};
